import styled, { css } from 'styled-components';
import { LabelProps } from '@/components/form/Label/Label';

export const Container = styled.div`
  ${({ theme, ...props }) => {
    return css`
      display: flex;
      gap: 0.5rem;
      justify-content: start;
      align-items: center;
      margin-bottom: 1rem;
    `;
  }};
`;

export const InputElement = styled.input`
  ${({ theme, ...props }) => {
    return css`
      background: ${theme.color.white};
      border-width: 2px;
      border-style: solid;
      border-radius: ${theme.radius.full};
      appearance: none;

      width: 1rem;
      height: 1rem;

      // Style
      border-color: ${theme.color.neutral_400};
      outline: 0;

      // Transition
      transition: ${theme.transition.all};

      &:checked {
        border-width: 5px;
        border-color: ${theme.color.secondary_400};
      }
    `;
  }};
`;

export const Label = styled.label<LabelProps>`
  ${({ theme, required, ...props }) => {
    return css`
      display: block;
      font-size: ${theme.typography.font_size.text_sm};
    `;
  }};
`;
